export default "/images/mf-small.svg?878155568cd41f731a1b2bd28e6a0c70";